/* eslint-disable no-undef */
import type Meeting from '@dytesdk/web-core';
import type {
  DyteSelf as Self,
  DyteParticipant as Participant,
} from '@dytesdk/web-core';
import { Message } from '@dytesdk/web-core';

type Peer = Self | Participant;

export type { Meeting, Peer, Self, Participant };

export interface PaginationCallbackParams {
  viewMode: 'ACTIVE_GRID' | 'PAGINATED';
  currentPage: number;
  pageCount: number;
}

export interface ChatUpdateParams {
  message: Message;
  messages: Message[];
}

export type RoomLeftState =
  | 'kicked'
  | 'ended'
  | 'left'
  | 'rejected'
  | 'connected-meeting'
  | 'disconnected';
